import React, { useEffect, useState, useCallback } from 'react';

import { retrieveFacilities, synchroniseFacilities } from '../../../services/FacilitiesService';

import { Table } from '../../common/table/Table';
import Modal from '../../common/modal/Modal';
import { FacilityEdit } from './FacilityEdit';

import './FacilitiesSearch.css';

export const FacilitiesSearch = ({ context, setSpinnerText, showToaster }) => {
  const [searchResults, setSearchResults] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [facility, setFacility] = useState(false);

  const retrieve = useCallback(async () => {
    setIsModalOpen(false);
    setSpinnerText('Retrieving Facilities');
    const [data, error] = await retrieveFacilities(context.username);
    if (data) {
      if (data.responseStatus === 'Success') {
        setSearchResults(data.facilities);
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(null);
  }, [context, setSpinnerText, showToaster]);

  useEffect(() => {
    retrieve();
  }, [retrieve]);

  const handleRowClick = (facility) => {
    setFacility(facility);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleSynchroniseFacilitiesClick = async () => {
    setSpinnerText('Synchronising Facilities');
    const [data, error] = await synchroniseFacilities(context.username);
    if (data) {
      if (data.responseStatus === 'Success') {
        showToaster(data);
        await retrieve();
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(null);
  };

  return (
    <div className="facilities-search">
      <Table
        tableData={searchResults}
        filterEnabled={true}
        tableTitle={'Facilities'}
        buttonText="Syncronise Facilities"
        onButtonClick={handleSynchroniseFacilitiesClick}
        onRowClick={handleRowClick}
        searchEnabled={true}
        maxRowCount={10}
        hiddenColumns={['externalReference']}
        horizontalScroll
      />
      {isModalOpen && (
        <Modal
          closeModal={closeModal}
          headerTitle={'Facility'}
          hideButton={true}
          setIsModalOpen={setIsModalOpen}
          width={'450px'}
          justifyContent={'center'}
          contentPadding={'2px'}
        >
          <FacilityEdit
            setIsModalOpen={setIsModalOpen}
            context={context}
            showToaster={showToaster}
            setSpinnerText={setSpinnerText}
            clineaseFacility={facility}
            retrieve={retrieve}
          />
        </Modal>
      )}
    </div>
  );
};
